import "../../libs/jquery.cycle2";

/**
 * a carousel with cycle2
 * @see http://jquery.malsup.com/cycle2/
 *
 * to auto-init the carousel the class 'cycle-slideshow' must be set and at least one image
 */
const CarouselDirective = function (imageOrientationDirective) {
  imageOrientationDirective = imageOrientationDirective[ 0 ] ? imageOrientationDirective[ 0 ] : null;

  return {
    restrict: 'A',
    scope: {
      carousel: '='
    },
    template: '<div class="images cycle-slideshow"' +
      'data-cycle-swipe="true"' +
      'data-cycle-swipe-fx="scrollHorz"' +
      'data-carousel-id="{{ carousel.id }}"' +
      'data-cycle-fx="scrollHorz"' +
      'data-cycle-timeout="0"' +
      'data-cycle-log="false"' +
      'data-cycle-prev=".prev.item-{{ carousel.id }}"' +
      'data-cycle-next=".next.item-{{ carousel.id }}"' +
      '>' +

      '<img ng-src="{{ carousel.detailData.prod_img_1 }}" alt="primary Product-Image" />' +
      '<img ng-repeat="img in getOtherSlideImages(carousel)" class="{{ carousel.id }}-image" ' +
      'ng-src="{{ img }}" alt="alternative Product-Image" />' +

      '</div>' +

      '<div class="controlContainer" ng-if="carousel && getOtherSlideImages(carousel).length > 0">' +
      '<a href="javascript:void(0)" class="prev item-{{ carousel.id }}">&lsaquo;</a>' +
      '<a href="javascript:void(0)" class="next item-{{ carousel.id }}">&rsaquo;</a>' +
      '</div>',

    link: function link(scope, element) {
      var $carousel = angular.element(element).children('.cycle-slideshow');

      /**
       * @param {Product} product
       * @return {string[]}
       */
      scope.getOtherSlideImages = function (product) {
        var pictures = [];
        if (product && product.detailData) {
          if (product.detailData.prod_img_2) {
            pictures.push(product.detailData.prod_img_2);
          }
          if (product.detailData.prod_img_3) {
            pictures.push(product.detailData.prod_img_3);
          }
        }
        return pictures;
      };

      // set heigh of image before the slide start
      // could not onLoad because can't set load-event on ng-repeat-Elements
      $carousel.on('cycle-before', function (event, optionHash, outgoingSlideEl, incomingSlideEl) {
        if (imageOrientationDirective) {
          imageOrientationDirective.orientate($carousel, angular.element(incomingSlideEl));
        }
      });

      // init carousel if (first) image was loaded
      // without images the cycle are not initialize
      $carousel.find('img').each(function (index, img) {
        angular.element(img).one('load', function () {
          $carousel.cycle();
        });
      });
    }
  };
};

export default CarouselDirective;

